const eventSourceCache = new Map<string, EventSource>()
const eventHandlers = new Map<string, Map<string, Set<(data: any, event: string) => void>>>()

export default function subscribeToEvent (
  topic: string,
  eventToHandle: string,
  eventHandler: (data: any, event: string) => void
) {
  const url = new URL(import.meta.env.VITE_SYNTELIX_CORE_API_URL + '/.well-known/mercure')
  url.searchParams.append('topic', topic)
  const urlKey = url.toString()

  if (!eventHandlers.has(urlKey)) {
    eventHandlers.set(urlKey, new Map())
  }
  const topicHandlers = eventHandlers.get(urlKey)!

  if (!topicHandlers.has(eventToHandle)) {
    topicHandlers.set(eventToHandle, new Set())
  }
  topicHandlers.get(eventToHandle)!.add(eventHandler)

  if (!eventSourceCache.has(urlKey)) {
    const eventSource = new EventSource(url)

    eventSource.onmessage = ev => {
      const { data, event } = JSON.parse(ev.data)
      const handlers = topicHandlers.get(event)
      if (handlers) {
        handlers.forEach(handler => handler(data, event))
      }
    }

    eventSourceCache.set(urlKey, eventSource)
  }
  return eventSourceCache.get(urlKey)!
}
